import { images } from '../constants';

const products = [
{
    id: 1,
    image: images.product1Gallery1,
    name: "RoofPrime - Roofing Service HTML5 Landing Page Template",
    price: 12,
    demoLink: "https://roofprime.asdesignsgalaxy.com/",
    buyLink: "https://asdesigns.lemonsqueezy.com/checkout/buy/59a102a6-7609-4c3c-8ab3-e4ec12451b9e",

    content: "RoofPrime is a premium HTML5 landing page for roofing and construction services. It’s fast, mobile-friendly, and designed to showcase installation, repair, and maintenance services.",
    description: "RoofPrime is a premium HTML5 landing page template crafted specifically for roofing contractors, construction companies, and home improvement services. Built with cutting-edge HTML5, CSS3, and JavaScript, it delivers a high-performance, mobile-friendly, and visually appealing experience across all devices. Designed to highlight roof installation, repair, replacement, and maintenance services, RoofPrime combines professional design, powerful functionality, and seamless navigation.",

    category: ["landing pages"],
    tags: ["roofing", "construction", "html5", "css3", "javascript", "responsive", "phpmailer"],

    features: [
        "Clean & Modern Design",
        "Built with HTML5, CSS3 & JavaScript",
        "100% Responsive & Mobile-Friendly",
        "Cross-Browser Compatibility",
        "Swiper Slider Integration",
        "Google Fonts & Font Awesome Icons",
        "Easy to Customize & Extend",
        "Well-Commented & Valid Code",
        "Detailed Documentation Included"
    ],

    sections: [
        {
            id: 1,
            title: "Hero Banner",
            description: "Highlight top services with a bold call-to-action"
        },
        {
            id: 2,
            title: "About Us",
            description: "Share your roofing story and mission"
        },
        {
        id: 3,
        title: "Our Services",
        description: "Display roofing, repair, and installation work"
        },
        {
        id: 4,
        title: "Counter",
        description: "Show completed projects and happy clients"
        },
        {
        id: 5,
        title: "Process",
        description: "Outline your simple roofing workflow"
        },
        {
        id: 6,
        title: "Cost Calculator",
        description: "Let users estimate roofing costs"
        },
        {
        id: 7,
        title: "Why Choose Us",
        description: "Emphasize trust, quality, and expertise"
        },
        {
        id: 8,
        title: "Projects",
        description: "Feature your latest roofing works"
        },
        {
        id: 9,
        title: "Pricing",
        description: "Present clear service packages"
        },
        {
        id: 10,
        title: "Get Quote",
        description: "Encourage quick roofing estimates"
        },
        {
        id: 11,
        title: "FAQs",
        description: "Answer common customer questions"
        },
        {
        id: 12,
        title: "Team",
        description: "Introduce skilled roofing experts"
        },
        {
        id: 13,
        title: "Testimonials",
        description: "Display real client reviews"
        },
        {
        id: 14,
        title: "Blogs",
        description: "Share roofing tips and updates"
        },
        {
        id: 15,
        title: "Contact",
        description: "Offer easy ways to reach you"
        },
        {
        id: 16,
        title: "Clients",
        description: "Show trusted partners and brands"
        }
    ],

    forms: [
        {
        id: 1,
        name: "Get Quote Form",
        description: "Allow users to request roofing estimates quickly and securely",
        technology: "PHPMailer (Basic Authentication)"
        },
        {
        id: 2,
        name: "Contact Form",
        description: "Let clients reach out for repair queries, inspections, or service details",
        technology: "PHPMailer (Basic Authentication)"
        },
        {
        id: 3,
        name: "Newsletter Signup",
        description: "Keep homeowners updated with roofing tips, offers, and seasonal care reminders",
        technology: "PHPMailer (Basic Authentication)"
        }
    ],

    perfectFor: [
        "Roofing & Renovation Companies",
        "Roof Installation & Repair Services",
        "Commercial & Residential Roofers",
        "Gutter & Siding Contractors",
        "Construction & Home Improvement Firms"
    ],

    whatYouGet: [
        "Complete HTML Template",
        "Documentation for setup & customization"
    ],

    gallery: {
        image1: images.product1Gallery1,
        image2: images.product1Gallery2,
        image3: images.product1Gallery3,
        image4: images.product1Gallery4,
        image5: images.product1Gallery5,
        image6: images.product1Gallery6,
        image7: images.product1Gallery7,
        image8: images.product1Gallery8,
        image9: images.product1Gallery9,
        image10: images.product1Gallery10,
    },

},
{
    id: 2,
    image: images.product2Gallery1,
    name: "Aquadive - Scuba Diving Center HTML5 Landing Page Template",
    price: 12,
    demoLink: "https://aquadive.asdesignsgalaxy.com/",
    buyLink: "https://asdesigns.lemonsqueezy.com/checkout/buy/527790cb-7d03-435d-a1b3-e60619e3a95a",

    content: "Aquadive is a modern HTML5 landing page for diving centers and tours. It’s responsive, ocean-inspired, and ideal for showcasing courses, trips, gear rentals, and testimonials.",
    description: "Aquadive is a modern HTML5 landing page template designed specifically for scuba diving centers, underwater adventure tours, and diving gear rentals. Developed with clean HTML5, CSS3, and JavaScript practices, it delivers a dynamic, ocean-inspired, and fully responsive layout that adapts beautifully to any device. Ideal for promoting certified diving courses, guided dive trips, premium equipment rentals, instructor profiles, and real diver testimonials, all while immersing visitors in a visually captivating marine experience.",

    category: ["landing pages"],
    tags: ["scuba diving", "travel", "adventure", "html5", "css3", "javascript", "responsive", "phpmailer"],

    features: [
        "Clean & Modern Design",
        "Built with HTML5, CSS3 & JavaScript",
        "100% Responsive & Mobile-Friendly",
        "Cross-Browser Compatibility",
        "Swiper Slider Integration",
        "Google Fonts & Font Awesome Icons",
        "Easy to Customize & Extend",
        "Well-Commented & Valid Code",
        "Detailed Documentation Included"
    ],
  
  sections: [
    {
      id: 1,
      title: "Hero Banner",
      description: "Catch attention with a stunning ocean intro"
    },
    {
      id: 2,
      title: "About Us",
      description: "Share your diving mission and experience"
    },
    {
      id: 3,
      title: "Services",
      description: "Promote training, tours, and rentals"
    },
    {
      id: 4,
      title: "Destinations",
      description: "Highlight popular dive spots"
    },
    {
      id: 5,
      title: "Tours",
      description: "Offer guided underwater adventures"
    },
    {
      id: 6,
      title: "Courses",
      description: "Showcase certification programs"
    },
    {
      id: 7,
      title: "Counter",
      description: "Display achievements and happy divers"
    },
    {
      id: 8,
      title: "Activities",
      description: "Present snorkeling, night dives, and more"
    },
    {
      id: 9,
      title: "Equipment Rentals",
      description: "Provide pro-grade diving gear"
    },
    {
      id: 10,
      title: "Testimonials",
      description: "Share guest feedback and success stories"
    },
    {
      id: 11,
      title: "Team",
      description: "Introduce skilled instructors"
    },
    {
      id: 12,
      title: "Pricing Plans",
      description: "Offer flexible packages"
    },
    {
      id: 13,
      title: "Gallery",
      description: "Show underwater moments and marine life"
    },
    {
      id: 14,
      title: "FAQs",
      description: "Answer common diving questions"
    },
    {
      id: 15,
      title: "Blogs",
      description: "Post tips, stories, and updates"
    },
    {
      id: 16,
      title: "Booking",
      description: "Easy online dive reservations"
    },
    {
      id: 17,
      title: "Contact",
      description: "Simple communication and directions"
    }
  ],
  
  forms: [
    {
      id: 1,
      name: "Booking Form",
      description: "Allow guests to easily book diving tours, excursions, or fun dive sessions",
      technology: "PHPMailer (Basic Authentication)"
    },
    {
      id: 2,
      name: "Contact Form",
      description: "Stay connected for questions about pricing, schedules, or support",
      technology: "PHPMailer (Basic Authentication)"
    },
    {
      id: 3,
      name: "Newsletter Signup",
      description: "Share diving tips, seasonal offers, and upcoming tour updates",
      technology: "PHPMailer (Basic Authentication)"
    }
  ],
  
  perfectFor: [
    "Scuba Diving & Snorkeling Centers",
    "Underwater Adventure & Tour Operators",
    "Diving Schools & Training Certifications",
    "Marine Exploration & Eco-Dive Organizations",
    "Equipment Rental & Dive Gear Service Providers"
  ],
  
  whatYouGet: [
    "Complete HTML Template",
    "Documentation for setup & customization"
  ],
  
  gallery: {
    image1: images.product2Gallery1,
    image2: images.product2Gallery2,
    image3: images.product2Gallery3,
    image4: images.product2Gallery4,
    image5: images.product2Gallery5,
    image6: images.product2Gallery6,
    image7: images.product2Gallery7,
    image8: images.product2Gallery8,
    image9: images.product2Gallery9,
    image10: images.product2Gallery10,
  },
},
{
  id: 3,
  image: images.product3Gallery1,
  name: "Scarlett - Personal Portfolio HTML5 Landing Page Template",
  price: 12,
  demoLink: "https://scarlett.asdesignsgalaxy.com/",
  buyLink: "https://asdesigns.lemonsqueezy.com/checkout/buy/30c7b74b-bab9-489f-9390-c5ecd8cc63e7",

  content: "Scarlett is a sleek HTML5 portfolio template for freelancers and creatives. It’s responsive, stylish, and built to showcase skills, personal branding, and professional work.",
  
  description: "Scarlett – Personal Portfolio HTML5 Landing Page Template is a sleek, creative, and personality-driven design tailored for freelancers, designers, developers, digital creators, photographers, and modern professionals who want to showcase their skills with impact. Developed using HTML5, CSS3, and JavaScript, it delivers a clean, stylish, and fully responsive interface that highlights individuality across all screen sizes. Scarlett helps professionals build a powerful online presence rooted in personal branding, expertise, confidence, and career-focused storytelling.",

  category: ["landing pages"],
  tags: ["portfolio", "personal", "freelancer", "html5", "css3", "javascript", "responsive", "phpmailer", "creative"],
  
  features: [
    "Clean & Modern Design",
    "Built with HTML5, CSS3 & JavaScript",
    "100% Responsive & Mobile-Friendly",
    "Cross-Browser Compatibility",
    "Swiper Slider Integration",
    "Google Fonts & Font Awesome Icons",
    "Easy to Customize & Extend",
    "Well-Commented & Valid Code",
    "Detailed Documentation Included"
  ],
  
  sections: [
    {
      id: 1,
      title: "Home",
      description: "Introduces you with a bold and professional hero section"
    },
    {
      id: 2,
      title: "About Me",
      description: "Highlights your story, personality, and career focus"
    },
    {
      id: 3,
      title: "Skills",
      description: "Displays your top abilities and strengths clearly"
    },
    {
      id: 4,
      title: "Counter",
      description: "Showcases key achievements and milestones"
    },
    {
      id: 5,
      title: "Experience",
      description: "Presents your work history and role expertise"
    },
    {
      id: 6,
      title: "Services",
      description: "Outlines the services you offer to clients"
    },
    {
      id: 7,
      title: "Portfolio",
      description: "Features your best creative and professional projects"
    },
    {
      id: 8,
      title: "Testimonials",
      description: "Shares feedback from clients and collaborators"
    },
    {
      id: 9,
      title: "Blogs",
      description: "Provides insights and updates related to your field"
    },
    {
      id: 10,
      title: "Contact",
      description: "Lets visitors reach out easily for work or inquiries"
    }
  ],
  
  forms: [
    {
      id: 1,
      name: "Contact Form",
      description: "Allows clients, collaborators, or recruiters to get in touch quickly and directly",
      technology: "PHPMailer (Basic Authentication)"
    }
  ],
  
  perfectFor: [
    "Web Developers & Front-End Designers",
    "Graphic Designers & Creative Artists",
    "Photographers & Visual Storytellers",
    "Freelancers Showcasing Personal Work",
    "Professionals Building a Modern Portfolio"
  ],
  
  whatYouGet: [
    "Complete HTML Template",
    "Documentation for setup & customization"
  ],
  
  gallery: {
    image1: images.product3Gallery1,
    image2: images.product3Gallery2,
    image3: images.product3Gallery3,
    image4: images.product3Gallery4,
    image5: images.product3Gallery5,
    image6: images.product3Gallery6,
    image7: images.product3Gallery7,
    image8: images.product3Gallery8,
    image9: images.product3Gallery9,
    image10: images.product3Gallery10,
  },
},
{
  id: 4,
  image: images.product4Gallery1,
  name: "Sparkle - Online Education & Courses HTML5 Landing Page Template",
  price: 12,
  demoLink: "https://sparkle.asdesignsgalaxy.com/",
  buyLink: "https://asdesigns.lemonsqueezy.com/checkout/buy/f785fe25-ef5b-4741-aa7c-b2c55aead28d",
  content: "Sparkle is a modern HTML5 education template for e-learning platforms and instructors. It’s responsive, clean, and designed to showcase courses, lessons, and student growth.",
  description: "Sparkle – Online Education & Courses HTML5 Landing Page Template is a fresh, engaging, and learning-centric design built for e-learning platforms, instructors, academies, coaching programs, training institutes, and digital skill-building communities. Developed with HTML5, CSS3, and JavaScript, it delivers a clean, intuitive, and fully responsive layout that performs flawlessly across all devices. Sparkle helps education brands build a powerful online presence focused on interactive learning, expert-led lessons, student growth, and real skill development.",
  

  category: ["landing pages"],
  tags: ["education", "online courses", "e-learning", "html5", "css3", "javascript", "responsive", "phpmailer", "training"],
  
  features: [
    "Clean & Modern Design",
    "Built with HTML5, CSS3 & JavaScript",
    "100% Responsive & Mobile-Friendly",
    "Cross-Browser Compatibility",
    "Swiper Slider Integration",
    "Google Fonts & Font Awesome Icons",
    "Easy to Customize & Extend",
    "Well-Commented & Valid Code",
    "Detailed Documentation Included"
  ],
  
  sections: [
    {
      id: 1,
      title: "Hero Banner",
      description: "Inspires learners to start their education journey"
    },
    {
      id: 2,
      title: "Features",
      description: "Highlights key benefits of online learning"
    },
    {
      id: 3,
      title: "About Us",
      description: "Shares our mission and teaching approach"
    },
    {
      id: 4,
      title: "Counter",
      description: "Displays student achievements and platform stats"
    },
    {
      id: 5,
      title: "Services",
      description: "Courses, learning tools, and support programs"
    },
    {
      id: 6,
      title: "Gallery",
      description: "Snapshots of classes and learning activities"
    },
    {
      id: 7,
      title: "Process",
      description: "Simple steps to begin learning"
    },
    {
      id: 8,
      title: "FAQs",
      description: "Answers to common questions about courses"
    },
    {
      id: 9,
      title: "Course Categories",
      description: "Browse subjects and learning paths"
    },
    {
      id: 10,
      title: "Courses",
      description: "Expert-led lessons designed for real skills"
    },
    {
      id: 11,
      title: "Testimonials",
      description: "Feedback from successful students"
    },
    {
      id: 12,
      title: "Instructors",
      description: "Meet our certified teachers and mentors"
    },
    {
      id: 13,
      title: "Pricing",
      description: "Affordable course packages"
    },
    {
      id: 14,
      title: "Registration",
      description: "Easy course enrollment"
    },
    {
      id: 15,
      title: "Blogs",
      description: "Tips on study, careers, and personal growth"
    },
    {
      id: 16,
      title: "Contact",
      description: "Reach our support team anytime"
    },
    {
      id: 17,
      title: "Partners",
      description: "Trusted educational collaborators"
    }
  ],
  
  forms: [
    {
      id: 1,
      name: "Course Registration Form",
      description: "Enroll in online courses, workshops, or training programs with ease",
      technology: "PHPMailer (Basic Authentication)"
    },
    {
      id: 2,
      name: "Contact Form",
      description: "Get in touch with our instructors or support team for quick assistance",
      technology: "PHPMailer (Basic Authentication)"
    },
    {
      id: 3,
      name: "Newsletter Signup",
      description: "Receive updates on new courses, study tips, and learning resources",
      technology: "PHPMailer (Basic Authentication)"
    }
  ],
  
  perfectFor: [
    "Online Learning Platforms",
    "Course & Training Providers",
    "Educational Institutes & Coaching Centers",
    "Skill-Development & eLearning Programs",
    "Teachers, Instructors & Academic Professionals"
  ],
  
  whatYouGet: [
    "Complete HTML Template",
    "Documentation for setup & customization"
  ],
  
  gallery: {
    image1: images.product4Gallery1,
    image2: images.product4Gallery2,
    image3: images.product4Gallery3,
    image4: images.product4Gallery4,
    image5: images.product4Gallery5,
    image6: images.product4Gallery6,
    image7: images.product4Gallery7,
    image8: images.product4Gallery8,
    image9: images.product4Gallery9,
    image10: images.product4Gallery10,
  },
},
{
  id: 5,
  image: images.product5Gallery1,
  name: "SunPower – Solar Energy HTML5 Landing Page Website Template",
  price: 12,
  demoLink: "https://sunpower.asdesignsgalaxy.com/",
  buyLink: "https://asdesigns.lemonsqueezy.com/checkout/buy/e2f8e2f9-b83f-4ba7-a34a-2fb26889bc79",
    content: "SunPower is a premium HTML5 template for solar and clean energy businesses. It’s fast, responsive, and designed to showcase services, projects, and client success stories.",
  description: "SunPower is a premium HTML5 landing page template crafted specifically for solar energy companies, renewable power providers, and clean tech businesses. Built with modern HTML5, CSS3, and JavaScript frameworks, it delivers a lightning-fast, eco-friendly, and fully responsive experience across all devices. Perfect for presenting solar solutions, green energy services, project portfolios, and client success stories, SunPower combines sleek design, powerful performance, and sustainable aesthetics to help energy brands inspire trust and promote a cleaner future online.",

  category: ["landing pages"],
  tags: ["solar energy", "renewable energy", "clean tech", "html5", "css3", "javascript", "responsive", "phpmailer", "green energy"],
  
  features: [
    "Clean & Modern Design",
    "Built with HTML5, CSS3 & JavaScript",
    "100% Responsive & Mobile-Friendly",
    "Cross-Browser Compatibility",
    "Swiper Slider Integration",
    "Google Fonts & Font Awesome Icons",
    "Easy to Customize & Extend",
    "Well-Commented & Valid Code",
    "Detailed Documentation Included"
  ],
  
  sections: [
    {
      id: 1,
      title: "Hero Banner",
      description: "Inspire with a bold solar message"
    },
    {
      id: 2,
      title: "About Us",
      description: "Share your clean energy vision"
    },
    {
      id: 3,
      title: "Services",
      description: "Present your solar solutions clearly"
    },
    {
      id: 4,
      title: "Counter",
      description: "Highlight key achievements and stats"
    },
    {
      id: 5,
      title: "Why Choose Us",
      description: "Build trust through innovation"
    },
    {
      id: 6,
      title: "Process",
      description: "Show your simple installation steps"
    },
    {
      id: 7,
      title: "Solar Calculator",
      description: "Estimate savings instantly"
    },
    {
      id: 8,
      title: "Projects",
      description: "Display successful installations"
    },
    {
      id: 9,
      title: "Pricing",
      description: "Offer clear and fair packages"
    },
    {
      id: 10,
      title: "Testimonials",
      description: "Feature real client feedback"
    },
    {
      id: 11,
      title: "Team",
      description: "Introduce your solar experts"
    },
    {
      id: 12,
      title: "Awards",
      description: "Showcase industry recognition"
    },
    {
      id: 13,
      title: "Get Quote",
      description: "Request a free consultation"
    },
    {
      id: 14,
      title: "Blogs",
      description: "Share energy news and insights"
    },
    {
      id: 15,
      title: "Contact",
      description: "Connect easily with your team"
    },
    {
      id: 16,
      title: "Partners",
      description: "Highlight trusted collaborations"
    }
  ],
  
  forms: [
    {
      id: 1,
      name: "Get Quote Form",
      description: "Help users request a free solar consultation easily",
      technology: "PHPMailer (Basic Authentication)"
    },
    {
      id: 2,
      name: "Contact Form",
      description: "Connect with customers for inquiries or support",
      technology: "PHPMailer (Basic Authentication)"
    },
    {
      id: 3,
      name: "Newsletter Signup",
      description: "Keep subscribers updated on solar tips and offers",
      technology: "PHPMailer (Basic Authentication)"
    }
  ],
  
  perfectFor: [
    "Solar Energy Companies",
    "Renewable Power Providers",
    "Green Technology Startups",
    "Solar Panel Installers",
    "Energy Consultants & Engineers"
  ],
  
  whatYouGet: [
    "Complete HTML Template",
    "Documentation for setup & customization"
  ],
  
  gallery: {
    image1: images.product5Gallery1,
    image2: images.product5Gallery2,
    image3: images.product5Gallery3,
    image4: images.product5Gallery4,
    image5: images.product5Gallery5,
    image6: images.product5Gallery6,
    image7: images.product5Gallery7,
    image8: images.product5Gallery8,
    image9: images.product5Gallery9,
    image10: images.product5Gallery10,
  },
},
{
  id: 6,
  image: images.product6Gallery1,
  name: "Lorenzo - Personal Portfolio HTML Landing Page Website Template",
  price: 12,
  demoLink: "https://lorenzo.asdesignsgalaxy.com/",
  buyLink: "https://asdesigns.lemonsqueezy.com/checkout/buy/c66a82e1-b51b-46a9-bfbb-0aef5ece039d",
  
content: "Lorenzo is a modern HTML5 portfolio template for creatives. It’s responsive, elegant, and built to showcase skills, personal branding, and professional work effectively.",
  description: "Lorenzo – Personal Portfolio HTML5 Landing Page Template is a refined, modern, and character-driven portfolio experience crafted for web developers, content writers, photographers, graphic designers, and creative professionals who want their personal brand to feel bold, polished, and authentic. Built with HTML5, CSS3, and JavaScript, it offers a fluid, elegant, and fully responsive layout that adapts seamlessly to every device. Lorenzo enables creatives to showcase their strengths through clean visual sections, expressive storytelling, strong identity elements, and skill-focused presentation, delivering an impactful digital presence that feels distinctive, inspiring, and professionally crafted.",

  category: ["landing pages"],
  tags: ["portfolio", "personal", "freelancer", "html5", "css3", "javascript", "responsive", "phpmailer", "creative", "web developer"],
  
  features: [
    "Clean & Modern Design",
    "Built with HTML5, CSS3 & JavaScript",
    "100% Responsive & Mobile-Friendly",
    "Cross-Browser Compatibility",
    "Swiper Slider Integration",
    "Google Fonts & Font Awesome Icons",
    "Easy to Customize & Extend",
    "Well-Commented & Valid Code",
    "Detailed Documentation Included"
  ],
  
  sections: [
    {
      id: 1,
      title: "Home",
      description: "Introduces your creative identity with a clean and bold hero layout"
    },
    {
      id: 2,
      title: "About",
      description: "Shares your journey as a web developer, writer, photographer, and designer"
    },
    {
      id: 3,
      title: "Counting",
      description: "Shows your key achievements and career milestones"
    },
    {
      id: 4,
      title: "Skills",
      description: "Highlights your core abilities and creative strengths"
    },
    {
      id: 5,
      title: "Services",
      description: "Outlines the professional services you provide"
    },
    {
      id: 6,
      title: "Resume",
      description: "Displays your professional roles and growth timeline"
    },
    {
      id: 7,
      title: "Portfolio",
      description: "Showcases your best projects across multiple fields"
    },
    {
      id: 8,
      title: "Testimonials",
      description: "Features real feedback from clients and collaborators"
    },
    {
      id: 9,
      title: "Blogs",
      description: "Shares insights, tips, and updates from your creative work"
    },
    {
      id: 10,
      title: "Contact",
      description: "Makes it easy for clients to reach you quickly"
    }
  ],
  
  forms: [
    {
      id: 1,
      name: "Contact Form",
      description: "Allows clients, collaborators, or recruiters to get in touch quickly and directly",
      technology: "PHPMailer (Basic Authentication)"
    }
  ],
  
  perfectFor: [
    "Web Developers & Front-End Creators",
    "Graphic Designers & Digital Artists",
    "Photographers & Visual Creators",
    "Freelancers Showcasing Their Expertise",
    "Professionals Building a Stylish Personal Brand"
  ],
  
  whatYouGet: [
    "Complete HTML Template",
    "Documentation for setup & customization"
  ],
  
  gallery: {
    image1: images.product6Gallery1,
    image2: images.product6Gallery2,
    image3: images.product6Gallery3,
    image4: images.product6Gallery4,
    image5: images.product6Gallery5,
    image6: images.product6Gallery6,
    image7: images.product6Gallery7,
    image8: images.product6Gallery8,
    image9: images.product6Gallery9,
    image10: images.product6Gallery10,
  },
},
{
  id: 7,
  image: images.product7Gallery1,
  name: "AirWave - Air Conditioning & Heating HTML5 Landing Page Template",
  price: 12,
  demoLink: "https://airwave.asdesignsgalaxy.com/",
  buyLink: "https://asdesigns.lemonsqueezy.com/checkout/buy/494161d4-e16b-437f-ad18-19899dad2cec",
  content: "AirWave is a professional HTML5 template for HVAC and climate control services. It’s responsive, clean, and designed to showcase solutions, technicians, services, and client testimonials.",
  description: "AirWave is a professional HTML5 landing page template designed for HVAC companies, air conditioning specialists, heating contractors, and climate control services. Built with the latest HTML5, CSS3, and JavaScript, it ensures a lightweight, responsive, and mobile-optimized website that builds customer trust and generates more leads. From showcasing HVAC solutions, certified technicians, and service packages to presenting client testimonials, project galleries, and easy service request form, AirWave delivers all the essentials in a modern, clean, and business-focused layout that increases engagement, enhances credibility, and supports long-term growth.",

  category: ["landing pages"],
  tags: ["hvac", "air conditioning", "heating", "cooling", "html5", "css3", "javascript", "responsive", "phpmailer", "climate control"],
  
  features: [
    "Clean & Modern Design",
    "Built with HTML5, CSS3 & JavaScript",
    "100% Responsive & Mobile-Friendly",
    "Cross-Browser Compatibility",
    "Swiper Slider Integration",
    "Google Fonts & Font Awesome Icons",
    "Easy to Customize & Extend",
    "Well-Commented & Valid Code",
    "Detailed Documentation Included"
  ],
  
  sections: [
    {
      id: 1,
      title: "Hero Banner",
      description: "Catch attention with HVAC services and seasonal offers"
    },
    {
      id: 2,
      title: "About Us",
      description: "Share your expertise, mission, and customer commitment"
    },
    {
      id: 3,
      title: "Our Services",
      description: "Showcase heating, cooling, and ventilation solutions"
    },
    {
      id: 4,
      title: "Stats / Counter",
      description: "Highlight projects, satisfied clients, and years of service"
    },
    {
      id: 5,
      title: "Process",
      description: "Explain your process for installation and maintenance"
    },
    {
      id: 6,
      title: "Portfolio",
      description: "Display successful HVAC installations and case studies"
    },
    {
      id: 7,
      title: "Why Choose Us",
      description: "Build trust with reliability, quality, and certified experts"
    },
    {
      id: 8,
      title: "Pricing Plans",
      description: "Present service packages and cost-effective options"
    },
    {
      id: 9,
      title: "Our Team",
      description: "Introduce skilled technicians and staff"
    },
    {
      id: 10,
      title: "Testimonials",
      description: "Show customer feedback and success stories"
    },
    {
      id: 11,
      title: "Latest Blogs",
      description: "Share HVAC tips, energy-saving advice, and updates"
    },
    {
      id: 12,
      title: "FAQs",
      description: "Answer common service and system questions"
    },
    {
      id: 13,
      title: "Request Service",
      description: "Let users schedule service instantly"
    },
    {
      id: 14,
      title: "Contact Section",
      description: "Provide quick ways to connect with you"
    },
    {
      id: 15,
      title: "Partners / Brands",
      description: "Highlight trusted HVAC brands and affiliations"
    }
  ],
  
  forms: [
    {
      id: 1,
      name: "Service Booking Form",
      description: "Let customers schedule AC installation, repair, or maintenance services with ease",
      technology: "PHPMailer (Basic Authentication)"
    },
    {
      id: 2,
      name: "Newsletter Signup",
      description: "Keep clients updated with seasonal offers, HVAC tips, and company news",
      technology: "PHPMailer (Basic Authentication)"
    }
  ],
  
  perfectFor: [
    "AC Installation & Repair Companies",
    "Heating & Ventilation Service Providers",
    "Residential & Commercial HVAC Solutions",
    "Cooling Plant & Industrial Climate Systems",
    "Professional Technicians & Service Contractors"
  ],
  
  whatYouGet: [
    "Complete HTML Template",
    "Documentation for setup & customization"
  ],
  
  gallery: {
    image1: images.product7Gallery1,
    image2: images.product7Gallery2,
    image3: images.product7Gallery3,
    image4: images.product7Gallery4,
    image5: images.product7Gallery5,
    image6: images.product7Gallery6,
    image7: images.product7Gallery7,
    image8: images.product7Gallery8,
    image9: images.product7Gallery9,
    image10: images.product7Gallery10,
  },
},
{
  id: 8,
  image: images.product8Gallery1,
  name: "Flavvora - Catering Service HTML5 Landing Page Template",
  price: 12,
  demoLink: "https://flavvora.asdesignsgalaxy.com/",
  buyLink: "https://asdesigns.lemonsqueezy.com/checkout/buy/7717eddb-8ec2-4b78-8afc-922b001e22f5",
  
content: "Flavvora is a premium HTML5 template for restaurants and catering services. It’s responsive, elegant, and designed to showcase menus, signature dishes, and event setups effectively.",
  description: "Flavvora is a premium HTML5 landing page template crafted exclusively for catering services, restaurants, and event dining businesses. Built with advanced HTML5, CSS3, and JavaScript frameworks, it delivers a lightweight, high-performing, and fully responsive experience across all devices. Ideal for presenting custom menus, signature dishes, chef specials, and elegant event setups, Flavvora combines modern design, seamless functionality, and tasteful aesthetics to create a captivating online presence for every culinary brand.",

  category: ["landing pages"],
  tags: ["catering", "restaurant", "food", "events", "html5", "css3", "javascript", "responsive", "phpmailer", "wedding"],
  
  features: [
    "Clean & Modern Design",
    "Built with HTML5, CSS3 & JavaScript",
    "100% Responsive & Mobile-Friendly",
    "Cross-Browser Compatibility",
    "Swiper Slider Integration",
    "Google Fonts & Font Awesome Icons",
    "Easy to Customize & Extend",
    "Well-Commented & Valid Code",
    "Detailed Documentation Included"
  ],
  
  sections: [
    {
      id: 1,
      title: "Hero Banner",
      description: "Greet visitors with an inviting intro and clear CTA"
    },
    {
      id: 2,
      title: "About Us",
      description: "Share your story and catering passion"
    },
    {
      id: 3,
      title: "Services",
      description: "Highlight event and food catering options"
    },
    {
      id: 4,
      title: "Counter",
      description: "Display key stats and achievements"
    },
    {
      id: 5,
      title: "Menu",
      description: "Showcase signature dishes and beverages"
    },
    {
      id: 6,
      title: "Process",
      description: "Explain your catering workflow"
    },
    {
      id: 7,
      title: "Why Choose Us",
      description: "Emphasize your quality and reliability"
    },
    {
      id: 8,
      title: "Gallery",
      description: "Present event visuals and food displays"
    },
    {
      id: 9,
      title: "Packages",
      description: "Offer catering plans for all occasions"
    },
    {
      id: 10,
      title: "Booking",
      description: "Allow quick event or catering reservations"
    },
    {
      id: 11,
      title: "FAQs",
      description: "Answer common client questions"
    },
    {
      id: 12,
      title: "Team",
      description: "Introduce your chefs and staff"
    },
    {
      id: 13,
      title: "Testimonials",
      description: "Show real client feedback"
    },
    {
      id: 14,
      title: "Blogs",
      description: "Share catering tips and updates"
    },
    {
      id: 15,
      title: "Contact",
      description: "Provide easy ways to connect"
    },
    {
      id: 16,
      title: "Partners",
      description: "Highlight trusted collaborations"
    }
  ],
  
  forms: [
    {
      id: 1,
      name: "Catering Booking Form",
      description: "Enable clients to book catering services quickly and effortlessly",
      technology: "PHPMailer (Basic Authentication)"
    },
    {
      id: 2,
      name: "Contact Form",
      description: "Let visitors reach out for event inquiries or custom menu requests",
      technology: "PHPMailer (Basic Authentication)"
    },
    {
      id: 3,
      name: "Newsletter Signup",
      description: "Keep customers updated with new dishes, offers, and events",
      technology: "PHPMailer (Basic Authentication)"
    }
  ],
  
  perfectFor: [
    "Catering Companies & Food Services",
    "Event & Wedding Caterers",
    "Personal Chefs & Private Dining",
    "Restaurants & Food Delivery Businesses",
    "Corporate & Hospitality Events"
  ],
  
  whatYouGet: [
    "Complete HTML Template",
    "Documentation for setup & customization"
  ],
  
  gallery: {
    image1: images.product8Gallery1,
    image2: images.product8Gallery2,
    image3: images.product8Gallery3,
    image4: images.product8Gallery4,
    image5: images.product8Gallery5,
    image6: images.product8Gallery6,
    image7: images.product8Gallery7,
    image8: images.product8Gallery8,
    image9: images.product8Gallery9,
    image10: images.product8Gallery10,
  },
}


];

export default products;